import { render, staticRenderFns } from "./BannerCustomHeroEdit.vue?vue&type=template&id=efacd7a0&"
import script from "./BannerCustomHeroEdit.vue?vue&type=script&lang=js&"
export * from "./BannerCustomHeroEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports